<template>
  <el-dialog v-loading="isLoading" :title="title" append-to-body :visible.sync="mIsShow">

    <el-form :model="form" label-width="80px" @submit.native.prevent style="max-width: 1030px;">
      <el-form-item label="姓名">
        <el-input v-model="form.Name"></el-input>
      </el-form-item>
      <el-form-item label="手機">
        <el-input v-model="form.Phone"></el-input>
      </el-form-item>
      <el-form-item label="郵遞區號">
        <el-input v-model="form.PostalCode"></el-input>
      </el-form-item>
      <el-form-item label="縣市">
        <el-input v-model="form.County"></el-input>
      </el-form-item>
      <el-form-item label="鄉鎮市區">
        <el-input v-model="form.Township"></el-input>
      </el-form-item>
      <el-form-item label="村里鄰">
        <el-input v-model="form.Village"></el-input>
      </el-form-item>
      <el-form-item label="街道細節">
        <el-input v-model="form.Detail"></el-input>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取消</el-button>
      <el-button type="primary" @click="submit">送出</el-button>
    </div>
  </el-dialog>
</template>

<script>
import MixinOfPreventLeaveEditPage from '@/utils/mixin-prevent-leave.vue'
import MixinLanguages from '@/utils/mixin-languages.vue'
export default {
  mixins: [MixinOfPreventLeaveEditPage, MixinLanguages],
  props: {
    isShow: {
      type: Boolean,
      required: true
    },
    oriObj: {
      default: () => {
        return null
      }
    },
    title: {
      default: '編輯收寄件人資訊'
    },
    orderID: {
      type: Number,
      required: true
    },
    contactType: { // sender or receiver
      type: String,
      required: true
    }
  },
  data () {
    return {
      form: {
      },
      mIsShow: false,
      isLoading: false
    }
  },
  computed: {
    isEdit () {
      return this.oriObj !== null
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    submit () {
      if (!this.validateInput()) {
        return
      }
      let payload = JSON.parse(JSON.stringify(this.form))
      console.log('payload', payload)
      if (!this.isEdit) throw String('ERROR modal contact')
      let promise = this.contactType === 'sender'
        ? this.$services.order.updateSender(this, this.orderID, payload)
        : this.$services.order.updateReceiver(this, this.orderID, payload)
      promise.then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (ok) this.onObjAddedit(res)
      }).catch(this.$handleServiceError)
    },
    onObjAddedit (res) {
      this.isSubmitted = true
      this.loadResult(res)
      this.$message({
        message: `${this.isEdit ? '修改' : '新增'}成功`,
        type: 'success'
      })
      this.form = {}
      this.$emit('submitted', res.data.result)
      this.close()
    },
    loadResult (res) {
      var newObj = res.data.result
      if (!this.isEdit) {
        this.$store.state.order.list.splice(0, 0, newObj)
      } else {
        newObj = Object.assign(this.oriObj, newObj)
        let idx = this.$store.state.postTag.list.findIndex(
          o => o.ID === newObj.ID
        )
        if (idx >= 0) {
          this.$set(this.$store.state.postTag.list, idx, newObj)
          this.oriObj = newObj
        } else {
          console.error(`unknown postTag for id ${newObj.ID}`)
        }
      }
    },
    validateInput () {
      var errMsg = null
      // if (!this.form.TitleTw) {
      //   errMsg = '請輸入繁中標籤'
      // }
      if (errMsg) {
        this.$alert(errMsg, '錯誤', {
          confirmButtonText: '確認',
          type: 'error'
        })
      }
      return errMsg === null
    }
  },
  created () {
    this.mIsShow = this.isShow
  },
  watch: {
    isShow () {
      this.mIsShow = this.isShow
    },
    mIsShow () {
      if (!this.mIsShow) this.close()
      else {
        if (this.oriObj) {
          this.form = JSON.parse(JSON.stringify(this.oriObj))
        } else {
          this.form = {
          }
        }
      }
    }
  }
}
</script>
